/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * AUTO-GENERATED REACT QUERY HOOKS - DO NOT EDIT
 * Generated from: MerchantMembersContract
 */

import { merchantmembersApi } from '../api/merchantmembers.api';
import { createMutationHook, createMessageMutationHook, createQueryHook, createPaginatedQueryHook } from './base.hooks';
import { queryKeys } from './query-keys';
import type { ListMembersQueryType, ListMembersParamsType, ListMembersResponseType, GetMemberParamsType, GetMemberResponseType, UpdateMemberCreditsBodyType, UpdateMemberCreditsParamsType, UpdateMemberCreditsResponseType, GetPersonalMemberCardParamsType, GetPersonalMemberCardResponseType, CreatePersonalMemberCardBodyType, CreatePersonalMemberCardParamsType, CreatePersonalMemberCardResponseType, UpdatePersonalMemberCardBodyType, UpdatePersonalMemberCardParamsType, UpdatePersonalMemberCardResponseType, GetCardBalancesParamsType, GetCardBalancesResponseType, CreateCardBalancesBodyType, CreateCardBalancesParamsType, CreateCardBalancesResponseType, CreateCardBackgroundBodyType, CreateCardBackgroundParamsType, CreateCardBackgroundResponseType, RemoveCardBackgroundBodyType, RemoveCardBackgroundParamsType, RemoveCardBackgroundResponseType, ListMerchantGroupsParamsType, ListMerchantGroupsResponseType, GetMerchantGroupParamsType, GetMerchantGroupResponseType, CreateMerchantGroupBodyType, CreateMerchantGroupParamsType, CreateMerchantGroupResponseType, UpdateMerchantGroupBodyType, UpdateMerchantGroupParamsType, UpdateMerchantGroupResponseType, CreateMerchantGroupMemberAssignmentBodyType, CreateMerchantGroupMemberAssignmentParamsType, CreateMerchantGroupMemberAssignmentResponseType, RemoveMerchantGroupMemberParamsType, RemoveMerchantGroupMemberResponseType, ListMemberGroupCardsParamsType, ListMemberGroupCardsResponseType, CreateMemberEnrollmentBodyType, CreateMemberEnrollmentParamsType, CreateMemberEnrollmentResponseType } from '@zlinkx/shared-v2';
import type { HookOptions, MutationHookReturn, QueryHookReturn } from '@/types/hook-generated.types';

export const useListMembers = createPaginatedQueryHook<ListMembersResponseType['data'][number], { merchantId: ListMembersParamsType['merchantId']; query?: ListMembersQueryType }>(
  ({ merchantId, query }) => merchantmembersApi.listMembers(merchantId, query),
  ({ merchantId, query }) => queryKeys.merchantmembers.listMembers(merchantId, query)
);

export const useGetMember = createQueryHook<GetMemberResponseType['data'], { merchantId: GetMemberParamsType['merchantId']; userId: GetMemberParamsType['userId'] }>(
  ({ merchantId, userId }) => merchantmembersApi.getMember(merchantId, userId),
  ({ merchantId, userId }) => queryKeys.merchantmembers.getMember(merchantId, userId)
);

export const useUpdateMemberCredits = createMessageMutationHook<{ merchantId: UpdateMemberCreditsParamsType['merchantId']; userId: UpdateMemberCreditsParamsType['userId']; data: UpdateMemberCreditsBodyType }>(
  (params) => merchantmembersApi.updateMemberCredits(params.merchantId, params.userId, params.data),
  {
    queryKey: queryKeys.merchantmembers.all,
  }
);

export const useGetPersonalMemberCard = createQueryHook<GetPersonalMemberCardResponseType['data'], { merchantId: GetPersonalMemberCardParamsType['merchantId']; userId: GetPersonalMemberCardParamsType['userId'] }>(
  ({ merchantId, userId }) => merchantmembersApi.getPersonalMemberCard(merchantId, userId),
  ({ merchantId, userId }) => queryKeys.merchantmembers.getPersonalMemberCard(merchantId, userId)
);

export const useCreatePersonalMemberCard = createMutationHook<CreatePersonalMemberCardResponseType['data'], { merchantId: CreatePersonalMemberCardParamsType['merchantId']; userId: CreatePersonalMemberCardParamsType['userId']; data: CreatePersonalMemberCardBodyType }>(
  (params) => merchantmembersApi.createPersonalMemberCard(params.merchantId, params.userId, params.data),
  {
    queryKey: queryKeys.merchantmembers.all,
  }
);

export const useUpdatePersonalMemberCard = createMutationHook<UpdatePersonalMemberCardResponseType['data'], { merchantId: UpdatePersonalMemberCardParamsType['merchantId']; userId: UpdatePersonalMemberCardParamsType['userId']; data: UpdatePersonalMemberCardBodyType }>(
  (params) => merchantmembersApi.updatePersonalMemberCard(params.merchantId, params.userId, params.data),
  {
    queryKey: queryKeys.merchantmembers.all,
  }
);

export const useGetCardBalances = createQueryHook<GetCardBalancesResponseType['data'], { merchantId: GetCardBalancesParamsType['merchantId']; cardId: GetCardBalancesParamsType['cardId'] }>(
  ({ merchantId, cardId }) => merchantmembersApi.getCardBalances(merchantId, cardId),
  ({ merchantId, cardId }) => queryKeys.merchantmembers.getCardBalances(merchantId, cardId)
);

export const useCreateCardBalances = createMutationHook<CreateCardBalancesResponseType['data'], { merchantId: CreateCardBalancesParamsType['merchantId']; cardId: CreateCardBalancesParamsType['cardId']; data: CreateCardBalancesBodyType }>(
  (params) => merchantmembersApi.createCardBalances(params.merchantId, params.cardId, params.data),
  {
    queryKey: queryKeys.merchantmembers.all,
  }
);

export const useCreateCardBackground = createMutationHook<CreateCardBackgroundResponseType['data'], { merchantId: CreateCardBackgroundParamsType['merchantId']; cardId: CreateCardBackgroundParamsType['cardId']; data: CreateCardBackgroundBodyType }>(
  (params) => merchantmembersApi.createCardBackground(params.merchantId, params.cardId, params.data),
  {
    queryKey: queryKeys.merchantmembers.all,
  }
);

export const useRemoveCardBackground = createMutationHook<RemoveCardBackgroundResponseType['data'], { merchantId: RemoveCardBackgroundParamsType['merchantId']; cardId: RemoveCardBackgroundParamsType['cardId']; data: RemoveCardBackgroundBodyType }>(
  (params) => merchantmembersApi.removeCardBackground(params.merchantId, params.cardId, params.data),
  {
    queryKey: queryKeys.merchantmembers.all,
  }
);

export const useListMerchantGroups = createPaginatedQueryHook<ListMerchantGroupsResponseType['data'][number], { merchantId: ListMerchantGroupsParamsType['merchantId'] }>(
  ({ merchantId }) => merchantmembersApi.listMerchantGroups(merchantId),
  ({ merchantId }) => queryKeys.merchantmembers.listMerchantGroups(merchantId)
);

export const useGetMerchantGroup = createQueryHook<GetMerchantGroupResponseType['data'], { merchantId: GetMerchantGroupParamsType['merchantId']; cardId: GetMerchantGroupParamsType['cardId'] }>(
  ({ merchantId, cardId }) => merchantmembersApi.getMerchantGroup(merchantId, cardId),
  ({ merchantId, cardId }) => queryKeys.merchantmembers.getMerchantGroup(merchantId, cardId)
);

export const useCreateMerchantGroup = createMutationHook<CreateMerchantGroupResponseType['data'], { merchantId: CreateMerchantGroupParamsType['merchantId']; data: CreateMerchantGroupBodyType }>(
  (params) => merchantmembersApi.createMerchantGroup(params.merchantId, params.data),
  {
    queryKey: queryKeys.merchantmembers.all,
  }
);

export const useUpdateMerchantGroup = createMutationHook<UpdateMerchantGroupResponseType['data'], { merchantId: UpdateMerchantGroupParamsType['merchantId']; cardId: UpdateMerchantGroupParamsType['cardId']; data: UpdateMerchantGroupBodyType }>(
  (params) => merchantmembersApi.updateMerchantGroup(params.merchantId, params.cardId, params.data),
  {
    queryKey: queryKeys.merchantmembers.all,
  }
);

export const useCreateMerchantGroupMemberAssignment = createMutationHook<CreateMerchantGroupMemberAssignmentResponseType['data'], { merchantId: CreateMerchantGroupMemberAssignmentParamsType['merchantId']; cardId: CreateMerchantGroupMemberAssignmentParamsType['cardId']; data: CreateMerchantGroupMemberAssignmentBodyType }>(
  (params) => merchantmembersApi.createMerchantGroupMemberAssignment(params.merchantId, params.cardId, params.data),
  {
    queryKey: queryKeys.merchantmembers.all,
  }
);

export const useRemoveMerchantGroupMember = createMessageMutationHook<{ merchantId: RemoveMerchantGroupMemberParamsType['merchantId']; cardId: RemoveMerchantGroupMemberParamsType['cardId']; userId: RemoveMerchantGroupMemberParamsType['userId'] }>(
  (params) => merchantmembersApi.removeMerchantGroupMember(params.merchantId, params.cardId, params.userId),
  {
    queryKey: queryKeys.merchantmembers.all,
  }
);

export const useListMemberGroupCards = createPaginatedQueryHook<ListMemberGroupCardsResponseType['data'][number], { merchantId: ListMemberGroupCardsParamsType['merchantId']; userId: ListMemberGroupCardsParamsType['userId'] }>(
  ({ merchantId, userId }) => merchantmembersApi.listMemberGroupCards(merchantId, userId),
  ({ merchantId, userId }) => queryKeys.merchantmembers.listMemberGroupCards(merchantId, userId)
);

export const useCreateMemberEnrollment = createMutationHook<CreateMemberEnrollmentResponseType['data'], { merchantId: CreateMemberEnrollmentParamsType['merchantId']; data: CreateMemberEnrollmentBodyType }>(
  (params) => merchantmembersApi.createMemberEnrollment(params.merchantId, params.data),
  {
    queryKey: queryKeys.merchantmembers.all,
  }
);